import * as React from "react";
import { DropDownList, DropDownListPortal } from "sb-resp-ui";
export class DropDownListWrapper extends React.PureComponent {
    render() {
        return (this.props.isPortalNeeded && this.props.rootElement ?
            React.createElement(DropDownListPortal, { classesModifier: this.props.classesModifier, hideHandler: this.props.hideHandler, rootElement: this.props.rootElement }, this.props.children)
            :
                React.createElement(DropDownList, { classesModifier: this.props.classesModifier, hideHandler: this.props.hideHandler }, this.props.children));
    }
}
//# sourceMappingURL=DropDownListWrapper.js.map